import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import { BiFontSize } from "react-icons/bi";

function ProjectCards(props) {
  return (
    <Button variant="link" style={{ padding: 0 }} href={props.ghLink || props.demoLink || props.leetcodeLink || props.codeforcesLink || props.hackerankLink} target="_blank">
      <Card className="project-card-view" style={{ width: "100%", minWidth: "350px" }}>
        <div style={{ position: "relative", display: "flex", gap: "10px", padding: "10px" ,backgroundColor: "#495057"}}>
          <Card.Img 
            variant="" 
            src={props.logo} 
            alt="card-img" 
            style={{
              marginLeft: "10px",
              marginTop: "10px",
              width: "60px",
              height: "60px",
              objectFit: "contain",
              flexShrink: 0
            }} 
          />
          <Card.Body style={{ padding: 20 }}>
            <Card.Title style={{
              fontSize: "1.50rem",     // increased font size
              fontWeight: 700,
              marginBottom: "0rem",
              boxShadow: "none",      // remove any box shadow
              textShadow: "none",     // remove text shadow
              borderBottom: "none"    // remove underline/bottom border
            }}>{props.title}</Card.Title>
            <Card.Text style={{ textAlign: "center" }}>
              {props.description}
            </Card.Text>
          </Card.Body>
        </div>

        {/* <Card.Img variant="top" src={props.imgPath} alt="card-img" /> */}
      </Card>
    </Button>
  );
}
export default ProjectCards;
